module.exports = __webpack_public_path__ + "static/Openscad-09cc9694093ef06de147f9ae48507de1.svg";